import { IncomingPurchaseRequest } from "./Data";

export const SELECTORS_PERSONAL_DATA = {
    addresses: ".addresses",
    addressItem: ".address-item",
    addNewButton: "#add_new_address",
    form: ".personal_data > .std-form",
    newAddressFieldset: "fieldset.new-address"
};

export const SELECTORS_FORM_SALE = {
    formContainer: "#sale-form",
    form: "[id^='step-']",
    back: "[data-back]",
    cancel: "[data-cancel]",
    next: "[data-next]",
    reveal: ".sale-button [data-reveal]",
    submit: "[data-submit]",
    tabs: "[data-tab]",
    step: ".step",
    openRequest: ".open-request",
    hero: ".cms-hero > figure"
};

export const SELECTORS_FORM_B2B = {
    ...SELECTORS_FORM_SALE,
    form: "form#sale-b2b"
};

export const SELECTORS_FORM_POS = {
    ...SELECTORS_FORM_SALE,
    form: "form#sale-pos"
};

export const TYPES_INCOMING_PURCHASE_REQUEST: { [key in keyof IncomingPurchaseRequest]: string } = {
    assesment: "string",
    available_from: "string",
    available_until: "string",
    brand: "string",
    buying_interest_brand: "string",
    buying_interest_internal: "string",
    buying_interest_model: "string",
    chain: "number",
    city: "string",
    color: "string",
    company: "string",
    crash: "number",
    ez: "string",
    features: "string",
    fgnr: "number",
    first_name: "string",
    front_tire: "number",
    kd_date: "string",
    kd_km: "number",
    keys: "number",
    km: "number",
    mail: "string",
    model: "string",
    name: "string",
    pickup: "boolean",
    plz: "string",
    pv: "number",
    pe_ek: "number",
    pe_vk: "number",
    rear_tire: "number",
    repairs: "string",
    street: "string",
    tel: "string",
    tire_age: "boolean",
    title: "string",
    tüv: "string",
    vb: "string"
};
